import { Component } from 'react';
import { ErrorState } from './ErrorState';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, retryCount: 0 };
        this.errorCounter = 0;
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        const name = this.props.name || 'unknown';
        console.error(`ErrorBoundary [${name}]:`, error, errorInfo);
        // Report to any global error handler
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('ftr:error-boundary', {
                detail: { name, message: error?.message, stack: error?.stack },
            }));
        }
    }

    handleRetry = () => {
        const maxRetries = 3;
        if (this.errorCounter >= maxRetries) return;
        this.errorCounter += 1;
        this.setState({ hasError: false, error: null, retryCount: this.errorCounter });
    };

    handleReset = () => {
        this.errorCounter = 0;
        this.setState({ hasError: false, error: null, retryCount: 0 });
    };

    render() {
        if (this.state.hasError) {
            const name = this.props.name || 'unknown';
            return (
                <ErrorState
                    title={this.props.fallbackTitle || 'Something went wrong'}
                    description={
                        this.state.retryCount >= 3
                            ? 'This section keeps crashing. You can go back to the homepage and try again.'
                            : (this.props.fallbackDescription || 'An unexpected error occurred while loading this section.')
                    }
                    onRetry={this.state.retryCount >= 3 ? undefined : (this.props.onRetry || this.handleRetry)}
                    onHome={this.state.retryCount >= 2 ? this.handleReset : undefined}
                    fullPage={this.props.fullPage}
                    componentName={name}
                />
            );
        }

        return this.props.children;
    }
}
